(() => {
  const CARD_SELECTOR = ".store-locator-card[data-store-modal-payload='true']";
  const IGNORE_CLICK_SELECTOR = "a, button, input, textarea, select, label";

  function setTextField(modal, field, value, options = {}) {
    const target = modal.querySelector(`[data-store-modal-field="${field}"]`);
    if (!target) return;

    const nextValue = (value || "").trim();
    if (!nextValue && options.hideWhenEmpty) {
      target.textContent = "";
      target.hidden = true;
      return;
    }

    target.hidden = false;
    target.textContent = nextValue;
  }

  function setContactLinkField(modal, field, value, linkType) {
    const target = modal.querySelector(`[data-store-modal-field="${field}"]`);
    if (!target) return;

    const nextValue = (value || "").trim();
    if (!nextValue) {
      target.textContent = "";
      target.hidden = true;
      target.removeAttribute("href");
      return;
    }

    target.hidden = false;
    target.textContent = nextValue;

    if (linkType === "phone") {
      const telValue = nextValue.replace(/\s+/g, "");
      target.href = `tel:${telValue}`;
      return;
    }

    if (linkType === "email") {
      target.href = `mailto:${nextValue}`;
    }
  }

  function setHtmlField(modal, field, value, options = {}) {
    const target = modal.querySelector(`[data-store-modal-field="${field}"]`);
    if (!target) return;

    const nextValue = (value || "").trim();
    if (!nextValue && options.hideWhenEmpty) {
      target.innerHTML = "";
      target.hidden = true;
      return;
    }

    target.hidden = false;
    target.innerHTML = nextValue;
  }

  function setStoreNameField(modal, value) {
    const target = modal.querySelector('[data-store-modal-field="name"]');
    if (!target) return;

    const nextValue = (value || "").trim();
    if (!nextValue) {
      target.textContent = "";
      target.hidden = true;
      return;
    }

    target.hidden = false;
    target.textContent = "";

    const separatorIndex = nextValue.indexOf(",");
    if (separatorIndex === -1) {
      target.textContent = nextValue;
      return;
    }

    const firstPart = nextValue.slice(0, separatorIndex).trim();
    const secondPart = nextValue.slice(separatorIndex + 1).trim();

    target.append(document.createTextNode(`${firstPart},`));
    target.append(document.createElement("br"));
    target.append(document.createTextNode(secondPart));
  }

  function setOpenStatusField(modal, state, detail, fallbackText) {
    const target = modal.querySelector('[data-store-modal-field="open-status"]');
    if (!target) return;

    const nextState = (state || "").trim();
    const nextDetail = (detail || "").trim();
    const nextFallback = (fallbackText || "").trim();

    if (!nextState && !nextFallback) {
      target.textContent = "";
      target.hidden = true;
      return;
    }

    target.hidden = false;
    target.textContent = "";

    if (!nextState) {
      target.textContent = nextFallback;
      return;
    }

    const label = nextState === "open" ? "Geöffnet" : "Geschlossen";
    const stateNode = document.createElement("span");
    stateNode.className = `store-locator-modal__open-status-state store-locator-modal__open-status-state--${nextState}`;
    stateNode.textContent = label;

    const detailNode = document.createElement("span");
    detailNode.className = "store-locator-modal__open-status-detail";
    detailNode.textContent = " "+nextDetail;

    target.append(stateNode);
    target.append(detailNode);
  }

  function setLinkField(modal, field, value, href) {
    const target = modal.querySelector(`[data-store-modal-field="${field}"]`);
    if (!target) return;

    const nextLabel = (value || "").trim();
    const nextHref = (href || "").trim();
    const shouldHide = !nextLabel || !nextHref;

    if (shouldHide) {
      target.hidden = true;
      target.removeAttribute("href");
      target.textContent = "";
      return;
    }

    target.hidden = false;
    target.textContent = nextLabel;
    target.href = nextHref;
  }

  function setImageField(modal, imageUrl, imageAlt) {
    const target = modal.querySelector('[data-store-modal-field="image"]');
    if (!target) return;

    const nextUrl = (imageUrl || "").trim();
    if (!nextUrl) {
      target.hidden = true;
      target.removeAttribute("src");
      target.alt = "";
      return;
    }

    target.hidden = false;
    target.src = nextUrl;
    target.alt = (imageAlt || "").trim();
  }

  function toggleSecondaryActionsVisibility(modal) {
    const secondaryContainer = modal.querySelector(".secondary-button-store");
    if (!secondaryContainer) return;

    const secondaryLinks = Array.from(
      secondaryContainer.querySelectorAll("a[data-store-modal-field]")
    );
    const hasVisibleSecondaryLink = secondaryLinks.some((link) => !link.hidden);

    secondaryContainer.classList.toggle("hidden", !hasVisibleSecondaryLink);
  }

  function hydrateModal(modal, card) {
    const { dataset } = card;
    const addressHtml =
      card.querySelector(".store-locator-card__address")?.innerHTML?.trim() ||
      dataset.storeAddress ||
      "";
    const formattedAddressHtml = addressHtml.includes("<br")
      ? addressHtml
      : addressHtml.replace(/\s*,\s*/, "<br>");
    const openingHoursHtml =
      card.querySelector(".store-locator-card__opening-hour")?.innerHTML?.trim() ||
      dataset.storeHours ||
      "";

    setStoreNameField(modal, dataset.storeName);
    setOpenStatusField(
      modal,
      dataset.storeOpenStatusState,
      dataset.storeOpenStatusDetail,
      dataset.storeOpenStatus
    );
    setHtmlField(modal, "address", formattedAddressHtml, { hideWhenEmpty: true });
    setContactLinkField(modal, "phone", dataset.storePhone, "phone");
    setContactLinkField(modal, "email", dataset.storeEmail, "email");
    setHtmlField(modal, "hours", openingHoursHtml, { hideWhenEmpty: true });
    setImageField(modal, dataset.storeImageUrl, dataset.storeName);
    setLinkField(modal, "route-link", dataset.storeRouteLabel || "Route", dataset.storeRouteUrl);
    setLinkField(modal, "video-link", dataset.storeVideoLabel, dataset.storeVideoUrl);
    setLinkField(modal, "url-link", dataset.storeUrlLabel, dataset.storeUrl);
    setLinkField(modal, "offer-link", dataset.storeOfferLabel, dataset.storeOfferUrl);
    toggleSecondaryActionsVisibility(modal);
  }

  function collectModalData(modal) {
    const getText = (field) =>
      (modal.querySelector(`[data-store-modal-field="${field}"]`)?.textContent || "").trim();
    const getHtml = (field) =>
      (modal.querySelector(`[data-store-modal-field="${field}"]`)?.innerHTML || "").trim();
    const getHref = (field) =>
      (modal.querySelector(`[data-store-modal-field="${field}"]`)?.getAttribute("href") || "").trim();

    const image = modal.querySelector('[data-store-modal-field="image"]');

    return {
      name: getText("name"),
      addressHtml: getHtml("address"),
      phone: getText("phone"),
      email: getText("email"),
      hoursHtml: getHtml("hours"),
      imageUrl: (image?.getAttribute("src") || "").trim(),
      routeUrl: getHref("route-link"),
      videoUrl: getHref("video-link"),
      storeUrl: getHref("url-link"),
      offerUrl: getHref("offer-link"),
    };
  }

  function openModalForCard(card) {
    const sectionId = card.dataset.storeLocatorSectionId;
    if (!sectionId) return;

    const modal = document.getElementById(`StoreLocatorModal-${sectionId}`);
    if (!modal) return;

    hydrateModal(modal, card);
    if (typeof modal.show === "function") {
      modal.show(card);
    } else {
      modal.setAttribute("open", "");
    }

    const modalData = collectModalData(modal);
    console.log("Store locator modal payload:", modalData);
  }

  document.addEventListener("click", (event) => {
    const infoButton = event.target.closest(".js-store-locator-open-modal");
    if (infoButton) {
      const infoCard = infoButton.closest(CARD_SELECTOR);
      if (!infoCard) return;
      event.preventDefault();
      openModalForCard(infoCard);
      return;
    }

    const card = event.target.closest(CARD_SELECTOR);
    if (!card) return;
    if (event.target.closest(IGNORE_CLICK_SELECTOR)) return;
    openModalForCard(card);
  });
})();
